<onyx-section [heading]="`${I18N}.heading`">
  @if (isOptional()) {
    <div rightHeading class="optional">
      <h6>{{ 'labels.optional' | translate }}</h6>
      <onyx-toggle
        data-testid="show-form-toggle"
        [(checked)]="showForm"
      ></onyx-toggle>
    </div>
  }

  <form [formGroup]="form()">
    @let controls = form().controls;
    <onyx-tabs
      data-testid="model-tabs"
      class="span-2"
      [formControl]="controls.model"
      [tabs]="models$ | async"
      label="labels.model"
      [fill]="true"
      [size]="32"
      width="100%"
    ></onyx-tabs>

    <onyx-tabs
      data-testid="make-tabs"
      [formControl]="controls.make"
      [tabs]="makes$ | async"
      label="labels.producent"
      [fill]="true"
      [size]="32"
      width="100%"
    ></onyx-tabs>

    <onyx-datepicker
      data-testid="next-legalization-date-datepicker"
      [formControl]="controls.nextLegalizationDate"
      label="labels.nextLegalizationDate"
      [yearsRange]="{ past: 0, future: 10 }"
      [warningTypes]="['pastDate']"
      [size]="32"
    ></onyx-datepicker>
  </form>
</onyx-section>
